import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import moment from 'moment';

@Component({
  selector: 'app-proof-payments-filter',
  templateUrl: './proof-payments-filter.component.html',
  styleUrls: ['./proof-payments-filter.component.css']
})
export class ProofPaymentsFilterComponent implements OnInit {
  proofsWithDate = true;
  dateRange = {
    from: moment().startOf('month').format('YYYY-MM-DD'),
    to: moment().endOf('month').format('YYYY-MM-DD')
  };

  @Output() filterChange: EventEmitter<any> = new EventEmitter<any>();

  constructor() {
  }

  ngOnInit(): void {
    this.filter();
  }

  filter() {
    this.filterChange.emit({
      dateRange: this.dateRange,
      proofsWithDate: this.proofsWithDate
    });
  }

}
